import { LinkItem } from "../components/atoms/LinkManager";
import {
  BusinessCardData,
  BusinessCardTemplate,
  ProcessBusinessCardData,
  ProcessData,
  UserData,
} from "../types/BusinessCardTypes";

export interface BusinessCardProcessPayload {
  userData: UserData;
  businessCardData: BusinessCardData;
  entityData: ProcessData["entity_data"] | null | undefined;
  template: BusinessCardTemplate;
  settings: {
    enableUserRegistration?: boolean;
    enableSaveContact?: boolean;
    saveStatistics?: boolean;
    addToCardHolderGroups?: boolean;
  };
}

const mapLinksToLinkItems = (
  links: ProcessBusinessCardData["links"] = []
): LinkItem[] =>
  links.map((link, index) => ({
    id: `link-${index}`,
    label: link.label,
    link: link.link,
    icon: link.icon || "website",
    icontype: link.icontype,
  }));

const mapUserData = (
  userInfo: ProcessData["process_data"]["user_data"]
): UserData => ({
  user_identification: userInfo?.user_identification ?? "",
  first_name: userInfo?.user_first_name?.trim() || "",
  last_name: userInfo?.user_last_name?.trim() || "",
  email: userInfo?.user_email?.trim() || "",
  phone: userInfo?.user_phone?.trim() || "",
  avatar: userInfo?.user_avatar?.trim() || "",
});

export const getDisplayName = (userData: UserData): string => {
  const fullName = `${userData.first_name} ${userData.last_name}`.trim();

  if (fullName) {
    return fullName;
  }

  if (userData.email) {
    return userData.email;
  }

  return "User";
};

export const mapProcessDataToBusinessCardPayload = (
  processData?: ProcessData | null
): BusinessCardProcessPayload | null => {
  if (!processData) return null;

  const businessCardInfo = processData.process_data?.businessCardData;
  const userInfo = processData.process_data?.user_data;
  const enableUserRegistration =
    processData.process_data?.enableUserRegistration;
  const enableSaveContact = processData.process_data?.enableSaveContact;
  const saveStatistics = processData.process_data?.saveStatistics;
  const addToCardHolderGroups = processData.process_data?.addToCardHolderGroups;

  if (!businessCardInfo || !userInfo) {
    return null;
  }

  const businessCardData: BusinessCardData = {
    jobTitle: businessCardInfo.jobTitle,
    description: businessCardInfo.description,
    links: mapLinksToLinkItems(businessCardInfo.links),
    uploadedFiles: businessCardInfo.uploadedFiles || [],
    booking: businessCardInfo.booking,
    allowVCardDownload: Boolean(enableSaveContact),
    showFooter:
      processData.process_data?.showFooter !== undefined
        ? processData.process_data?.showFooter
        : true,
  };

  return {
    userData: mapUserData(userInfo),
    businessCardData,
    entityData: processData.entity_data,
    template: processData.process_data?.template || "default",
    settings: {
      enableUserRegistration,
      enableSaveContact,
      saveStatistics,
      addToCardHolderGroups,
    },
  };
};
